import spriteHref from '../components/spriteHref';

export default function RedirectModal() {
    redirectInfoScreen()
}

function redirectInfoScreen() {

    var trigger = document.querySelectorAll('.open-redirect-modal');

    trigger.forEach(el => el.addEventListener('click', e => {
        e.preventDefault();

        var type = e.target.getAttribute("data-redirect-type");
        var redirectTitle = e.target.getAttribute("data-redirect-title");
        var logo = e.target.getAttribute('data-redirect-logo');

        var redirectSplash = document.createElement("div");

        if (type == "trade-point") {
            redirectSplash.innerHTML = '<div class="redirect-splash trade-point"><div class="redirect-splash-inner"><div class="redirect-splash-close"><svg class="icon"><use href="' + spriteHref('sprite-icon-cross') + '"></use></svg></div><div class="redirect-splash-title">' + redirectTitle + '</div><img src="' + logo + '" alt="redirecting you to Trade Point"><a href="' + e.currentTarget.href +'" class="button" target="_blank">Visit Trade Point <svg class="icon"><use href="' + spriteHref('button-arrow-right') + '"></use></svg ></a></div></div>';
        }
        else {
            redirectSplash.innerHTML = '<div class="redirect-splash"><div class="redirect-splash-inner"><div class="redirect-splash-close"><svg class="icon"><use href="' + spriteHref('sprite-icon-cross') + '"></use></svg></div><div class="redirect-splash-title">' + redirectTitle + '</div><img src="' + logo + '" alt="redirecting you to B&Q"><a href="' + e.currentTarget.href + '" class="button grey redirect-splash-button" target="_blank">Visit B&Q<svg class="icon"><use href="' + spriteHref('button-arrow-right') + '"></use></svg></a></div></div>';
        }

        document.body.appendChild(redirectSplash);
        redirectSplash.firstElementChild.classList.add('loaded');
        closeRedirectModal(redirectSplash);

    }));

    function closeRedirectModal(redirectSplash) {
        var close = document.querySelector('.redirect-splash-close');

        close.addEventListener("click", function () {
            redirectSplash.firstElementChild.classList.remove('loaded');
            setTimeout(function () {
                redirectSplash.remove();
            }, 1000)
        });
    }
}